import CookieName from '../../utils/cookies/cookieName';

export const OWNING_TEAM_NAME = 'Subscriptions - Programs & Upsells';

export const EMPTY_PAGE_CONTENT_ERROR =
  '[LoginConfirmationPage] Empty LoginConfirmationPage content received for id:';

export const MISSING_CURRENT_PROGRAM_ERROR = `[LoginConfirmationPage] Could not resolve current program. Missing ${CookieName.TOGGLED_SUBSCRIPTION_PROGRAM} cookie.`;

export const ERROR_PROPS = { error: true };

export const LOGIN_CONFIRMATION_FORM = 'LOGIN_CONFIRMATION_FORM';

export const DEFAULT_LOGIN_CONFIRMATION_FLOW = 'default_login_confirmation';
